export const TabValue = {
  VIEW: 'view',
  SYSTEM: 'system',
  CUSTOM_FIELDS: 'customFields',
  DEPENDENCIES: 'dependencies',
  LINKED_IDEAS: 'linkedIdeas',
} as const;

export const PanelTabValue = {
  NEEDS_ATTENTION: 'needsAttention',
  MISSING_DATA: 'missingData',
  DEPENDENCY: 'dependency',
} as const;

export type TabValueType = (typeof TabValue)[keyof typeof TabValue];
export type PanelTabValueType = (typeof PanelTabValue)[keyof typeof PanelTabValue];
